<div class="grid-x">
  <h4 class="cell small-10">{{item.type}}</h4>
  <button class="cell small-2 button tiny" (click)="delete()">DELETE</button>
  <div class="cell small-12">
    <label>
      Position
      <select [(ngModel)]="item.position">
        @for (option of positions; track option) {
          <option [value]="option">{{option}}</option>
        }
      </select>
    </label>
  </div>
</div>